/**
 * ENUM
 * Nivel de seguranca exigida em uma assinatura de contrato.
 */
export enum DokfySignatureSecurityLevelEnum {
    INVITE = 'INVITE',
    SIMPLE_REGISTER = 'SIMPLE_REGISTER',
    FULL_REGISTER = 'FULL_REGISTER'
}
